import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent } from '@mui/material';
import {
  Web as WebIcon,
  Smartphone as MobileIcon,
  Computer as DesktopIcon,
  Psychology as ConsultingIcon,
  Cloud as CloudIcon,
  Api as ApiIcon,
} from '@mui/icons-material';
import { wolvesLabsColors } from '../../theme/wolvesLabsTheme';

const Services: React.FC = () => {
  const services = [
    {
      icon: <WebIcon sx={{ fontSize: 60 }} />,
      title: 'Desarrollo Web',
      description:
        'Aplicaciones web modernas, responsivas y escalables. Desde landing pages hasta sistemas empresariales completos.',
      features: ['React', 'Node.js', 'Laravel'],
      color: wolvesLabsColors.tech,
    },
    {
      icon: <MobileIcon sx={{ fontSize: 60 }} />,
      title: 'Desarrollo Móvil',
      description:
        'Apps nativas y multiplataforma para iOS y Android que tus usuarios amarán usar.',
      features: ['React Native', 'Flutter', 'iOS Native', 'Android Native'],
      color: wolvesLabsColors.highlight,
    },
    {
      icon: <DesktopIcon sx={{ fontSize: 60 }} />,
      title: 'Aplicaciones Desktop',
      description:
        'Software de escritorio potente y eficiente para Windows, macOS y Linux.',
      features: ['PHP', 'Java'],
      color: wolvesLabsColors.secondary,
    },
    {
      icon: <ApiIcon sx={{ fontSize: 60 }} />,
      title: 'APIs & Backend',
      description:
        'Arquitecturas robustas, APIs RESTful y microservicios escalables para tu negocio.',
      features: ['REST APIs', 'GraphQL', 'Microservicios', 'Bases de Datos'],
      color: wolvesLabsColors.accent,
    },
    {
      icon: <CloudIcon sx={{ fontSize: 60 }} />,
      title: 'Cloud & DevOps',
      description:
        'Despliegue en la nube, CI/CD, y gestión de infraestructura moderna.',
      features: ['AWS', 'Google Cloud', 'Docker', 'Kubernetes'],
      color: wolvesLabsColors.tech,
    },
    {
      icon: <ConsultingIcon sx={{ fontSize: 60 }} />,
      title: 'Consultoría & Asesoría',
      description:
        'Guía experta en arquitectura de software, mejores prácticas y optimización de procesos.',
      features: ['Arquitectura', 'Code Review', 'Mentoría', 'Auditorías'],
      color: wolvesLabsColors.primary,
    },
  ];

  return (
    <Box
      id="services"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: 'white',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2rem', md: '3rem' },
              fontWeight: 800,
              mb: 2,
              background: wolvesLabsColors.gradients.blue,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Nuestros Servicios
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: wolvesLabsColors.gray[600],
              maxWidth: '700px',
              mx: 'auto',
              lineHeight: 1.8,
            }}
          >
            Ofrecemos una amplia gama de servicios de desarrollo de software 
            para cubrir todas tus necesidades tecnológicas
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  borderRadius: 0,
                  transition: 'all 0.3s ease',
                  border: '2px solid transparent',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: `0 20px 40px ${service.color}30`,
                    border: `2px solid ${service.color}`,
                  },
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box
                    sx={{
                      color: service.color,
                      mb: 3,
                      display: 'inline-block',
                      p: 2,
                      borderRadius: 0,
                      backgroundColor: `${service.color}15`,
                    }}
                  >
                    {service.icon}
                  </Box>

                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      mb: 2,
                      color: wolvesLabsColors.primary,
                    }}
                  >
                    {service.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: wolvesLabsColors.gray[600],
                      mb: 3,
                      lineHeight: 1.7,
                    }}
                  >
                    {service.description}
                  </Typography>

                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {service.features.map((feature, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          px: 1.5,
                          py: 0.5,
                          borderRadius: 0,
                          backgroundColor: `${service.color}15`,
                          color: service.color,
                          fontSize: '0.75rem',
                          fontWeight: 600,
                        }}
                      >
                        {feature}
                      </Box>
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;

